// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Complaint Details Page - Minimalist Theme */
.complaint-details-container {
  padding: 1.5rem;
  max-width: 1220px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
  background: var(--bg-primary);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  color: var(--text-primary);
}

.complaint-hero-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: var(--shadow-md);
  margin-bottom: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.complaint-hero-card:hover {
  border-color: var(--accent-primary);
}

/* Header Section */
.complaint-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.inline-status {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  font-size: 0.9375rem;
}

.back-button:hover {
  background: var(--nav-hover-bg);
  color: var(--text-primary);
  border-color: var(--accent-primary);
}

.complaint-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.015em;
}

.status-update-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: var(--accent-primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.9375rem;
  box-shadow: var(--shadow-sm);
}

.status-update-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
  background: var(--accent-hover);
}

.status-update-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.complaint-hero-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}

.meta-pill {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  box-shadow: var(--shadow-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.meta-pill:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--accent-primary);
}

.meta-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-secondary);
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.meta-value {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.meta-hint {
  font-size: 0.8125rem;
  color: var(--accent-primary);
  font-weight: 600;
}

.link-pill {
  cursor: pointer;
  text-align: left;
  background: var(--bg-primary);
}

.link-pill:hover {
  background: var(--nav-hover-bg);
}

/* Info Grid */
.complaint-info-grid {
  display: grid;
  gap: 1.5rem;
}

/* 3-Column Bento Grid for Complaints */
.complaints-bento-grid {
  grid-template-columns: repeat(3, 1fr);
}

@media (max-width: 1280px) {
  .complaints-bento-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .complaints-bento-grid {
    grid-template-columns: 1fr;
  }
}

.info-card {
  background: var(--bg-secondary);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-color);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.info-card:hover {
  transform: translateY(-2px);
  border-color: var(--accent-primary);
  box-shadow: var(--shadow-md);
}

.info-card-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 1.25rem;
  letter-spacing: -0.015em;
}

/* Info Grid Layout */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.25rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.info-item label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-secondary);
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.info-item span:not(.status-badge) {
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 600;
}

.uuid {
  font-family: 'SF Mono', 'Courier New', Courier, monospace;
  font-size: 0.875rem;
  color: var(--text-primary);
  background: var(--nav-hover-bg);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  word-break: break-all;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Description Card */
.description-card {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.complaint-details-container .complaint-full-description {
  background: var(--bg-primary);
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  line-height: 1.6;
  white-space: pre-wrap;
  font-size: 1rem;
  color: var(--text-primary);
}

/* Metadata Grid */
.metadata-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
}

.metadata-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.metadata-item label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: capitalize;
}

.metadata-item span {
  color: var(--text-primary);
  font-size: 0.92rem;
  font-family: 'SF Mono', Courier, monospace;
  background: var(--nav-hover-bg);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  word-break: break-all;
}

/* Status badge styles moved to status-badge.css */

/* Смена статуса жалобы: портал + оверлей + кастомный список (без нативного select) */
.complaint-status-shell {
  position: fixed;
  inset: 0;
  z-index: 10000;
  pointer-events: none;
}

.complaint-status-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.38);
  pointer-events: auto;
  cursor: pointer;
}

[data-theme='dark'] .complaint-status-overlay {
  background: rgba(0, 0, 0, 0.55);
}

.complaint-status-popup {
  width: min(300px, calc(100vw - 32px));
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  padding: 16px;
  transform-origin: 50% 0;
}

.complaint-status-popup--portal {
  position: fixed;
  z-index: 1;
  pointer-events: auto;
}

[data-theme='dark'] .complaint-status-popup {
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}

.complaint-status-popup__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-weight: 600;
  color: var(--text-primary);
}

.complaint-status-popup__close {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  line-height: 1;
  color: var(--text-secondary);
  padding: 4px 6px;
  border-radius: 8px;
  transition: background 0.15s ease, color 0.15s ease;
}

.complaint-status-popup__close:hover {
  background: var(--nav-hover-bg);
  color: var(--text-primary);
}

.complaint-status-popup__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* Кастомное поле статуса внутри попапа */
.complaint-status-field {
  position: relative;
  margin-bottom: 16px;
}

.complaint-status-field__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px 10px 10px 14px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.complaint-status-field__trigger:hover:not(:disabled) {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.2);
}

.complaint-status-field__trigger:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.complaint-status-field__label {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.complaint-status-field__chevron {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-right: 2px;
  border-radius: 8px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  transition: transform 0.2s ease, border-color 0.15s ease;
}

.complaint-status-field__chevron--open {
  transform: rotate(180deg);
}

.complaint-status-field__menu {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 6px);
  z-index: 2;
  padding: 6px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  max-height: 220px;
  overflow-y: auto;
}

[data-theme='dark'] .complaint-status-field__menu {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
}

.complaint-status-field__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
  transition: background 0.12s ease;
}

.complaint-status-field__option:hover {
  background: var(--nav-hover-bg);
}

.complaint-status-field__option--active {
  background: rgba(59, 130, 246, 0.08);
  color: var(--accent-primary);
}

.complaint-status-field__check {
  flex-shrink: 0;
  opacity: 0.85;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: var(--bg-secondary);
  padding: 2rem;
  border-radius: 20px;
  width: 92%;
  max-width: 480px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border-color);
}

.modal-content h3 {
  margin: 0 0 1.5rem;
  color: var(--text-primary);
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
}

.status-options {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
}

.status-option {
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  padding: 1rem;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
}

.status-option:hover {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
  transform: translateX(4px);
}

.status-option input[type="radio"] {
  margin: 0;
  width: 1.25rem;
  height: 1.25rem;
  accent-color: var(--accent-primary);
}

.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.cancel-button,
.confirm-button {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9375rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.cancel-button {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
}

.cancel-button:hover { 
  background: var(--nav-hover-bg); 
  color: var(--text-primary);
}

.confirm-button {
  background: var(--accent-primary);
  color: #fff;
  border: none;
  box-shadow: var(--shadow-sm);
}

.confirm-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
  background: var(--accent-hover);
}

.confirm-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

/* Loading and Error States */

.error-message {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  padding: 1.5rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  border: 1px solid rgba(239, 68, 68, 0.2);
  font-weight: 600;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--text-secondary);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.empty-state-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-primary);
  opacity: 0.8;
}

.empty-state-text {
  font-size: 1.125rem;
  color: var(--text-primary);
  font-weight: 600;
}

/* Clickable UUID */
.clickable-uuid {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px;
  padding: 0.5rem;
  margin: -0.5rem;
  border: 1px solid transparent;
}

.clickable-uuid:hover {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
  transform: translateY(-1px);
}

.click-hint {
  display: block;
  font-size: 0.8125rem;
  color: var(--accent-primary);
  margin-top: 0.25rem;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
}

.clickable-uuid:hover .click-hint { opacity: 1; }
.clickable-uuid:hover .uuid {
  background: var(--bg-primary);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.link-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid var(--accent-primary);
  background: rgba(139, 92, 246, 0.1);
  color: var(--accent-primary);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.link-chip:hover {
  background: var(--accent-primary);
  color: white;
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* Responsive Design */
@media (max-width: 900px) {
  .complaint-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 768px) {
  .complaint-details-container {
    padding: 1rem;
    margin-top: 52px;
  }

  .complaint-title {
    font-size: 1.65rem;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .modal-content {
    width: 96%;
    padding: 1.4rem;
  }

  .modal-actions {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .complaint-details-container {
    padding: 0.75rem;
  }

  .metadata-grid {
    grid-template-columns: 1fr;
  }
}

/* Focus states for accessibility */
.back-button:focus,
.status-update-button:focus,
.cancel-button:focus,
.confirm-button:focus,
.status-option:focus-within {
  outline: 2px solid #6366f1;
  outline-offset: 2px;
}

/* Review/Comment Card Styles */
.review-card {
  grid-column: 1 / -1;
}

.review-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.review-comment-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.review-comment-section label {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.05em;
  display: block;
}

.review-comment-text {
  background: var(--bg-primary);
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  line-height: 1.6;
  white-space: pre-wrap;
  font-size: 1rem;
  color: var(--text-primary);
  min-height: 80px;
}

.review-comment-date {
  font-size: 0.875rem;
  color: var(--text-secondary);
  font-weight: 500;
  padding-left: 0.25rem;
}

.review-navigation-buttons {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.review-navigation-buttons .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  font-family: inherit;
}

.review-navigation-buttons .btn-primary {
  background: var(--accent-primary);
  color: white;
  box-shadow: var(--shadow-sm);
}

.review-navigation-buttons .btn-primary:hover {
  transform: translateY(-1px);
  background: var(--accent-hover);
  box-shadow: var(--shadow-md);
}

.review-navigation-buttons .btn-secondary {
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.review-navigation-buttons .btn-secondary:hover {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
}

.review-placeholder {
  padding: 2rem;
  text-align: center;
  color: var(--text-secondary);
  font-style: italic;
}

.retry-button {
  margin-top: 1rem;
  padding: 10px 20px;
  background: var(--accent-primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.9375rem;
  box-shadow: var(--shadow-sm);
}

.retry-button:hover {
  transform: translateY(-1px);
  background: var(--accent-hover);
  box-shadow: var(--shadow-md);
}

/* Print Styles */
@media print {
  .complaint-details-container {
    background: white;
    margin-top: 0;
    padding: 1rem;
  }

  .complaint-header .status-update-button,
  .modal-overlay {
    display: none;
  }

  .info-card {
    box-shadow: none;
    border: 1px solid #e5e7eb;
  }
}
/* Тёмная тема (DEV): контейнер деталей жалобы был белым */
:root[data-theme='dark'] .complaint-details-container {
  background: var(--bg-card);
}
`, "",{"version":3,"sources":["webpack://./src/css/complaint-details.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,6BAA6B;EAC7B,yGAAyG;EACzG,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA,kDAAkD;;AAElD,qFAAqF;AACrF;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iDAAiD;EACjD,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6BAA6B;;AAE7B;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;EACV,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA,oCAAoC,UAAU,EAAE;AAChD;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,uCAAuC;EACvC,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mCAAmC;AACnC;;;;;EAKE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,aAAa;IACb,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;AACA,0DAA0D;AAC1D;EACE,0BAA0B;AAC5B","sourcesContent":["/* Complaint Details Page - Minimalist Theme */\n.complaint-details-container {\n  padding: 1.5rem;\n  max-width: 1220px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n  background: var(--bg-primary);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n  color: var(--text-primary);\n}\n\n.complaint-hero-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: var(--shadow-md);\n  margin-bottom: 1.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.complaint-hero-card:hover {\n  border-color: var(--accent-primary);\n}\n\n/* Header Section */\n.complaint-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.inline-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n}\n\n.back-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-decoration: none;\n  font-size: 0.9375rem;\n}\n\n.back-button:hover {\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n  border-color: var(--accent-primary);\n}\n\n.complaint-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  letter-spacing: -0.015em;\n}\n\n.status-update-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: var(--accent-primary);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.9375rem;\n  box-shadow: var(--shadow-sm);\n}\n\n.status-update-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n  background: var(--accent-hover);\n}\n\n.status-update-button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.complaint-hero-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n}\n\n.meta-pill {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.meta-pill:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n  border-color: var(--accent-primary);\n}\n\n.meta-label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.meta-value {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.meta-hint {\n  font-size: 0.8125rem;\n  color: var(--accent-primary);\n  font-weight: 600;\n}\n\n.link-pill {\n  cursor: pointer;\n  text-align: left;\n  background: var(--bg-primary);\n}\n\n.link-pill:hover {\n  background: var(--nav-hover-bg);\n}\n\n/* Info Grid */\n.complaint-info-grid {\n  display: grid;\n  gap: 1.5rem;\n}\n\n/* 3-Column Bento Grid for Complaints */\n.complaints-bento-grid {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n@media (max-width: 1280px) {\n  .complaints-bento-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .complaints-bento-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.info-card {\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  padding: 1.5rem;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-color);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.info-card:hover {\n  transform: translateY(-2px);\n  border-color: var(--accent-primary);\n  box-shadow: var(--shadow-md);\n}\n\n.info-card-title {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 1.25rem;\n  letter-spacing: -0.015em;\n}\n\n/* Info Grid Layout */\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.25rem;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.info-item label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.info-item span:not(.status-badge) {\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.uuid {\n  font-family: 'SF Mono', 'Courier New', Courier, monospace;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n  background: var(--nav-hover-bg);\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n  word-break: break-all;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Description Card */\n.description-card {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.complaint-details-container .complaint-full-description {\n  background: var(--bg-primary);\n  padding: 1.5rem;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  line-height: 1.6;\n  white-space: pre-wrap;\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n\n/* Metadata Grid */\n.metadata-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.metadata-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.metadata-item label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: capitalize;\n}\n\n.metadata-item span {\n  color: var(--text-primary);\n  font-size: 0.92rem;\n  font-family: 'SF Mono', Courier, monospace;\n  background: var(--nav-hover-bg);\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n  word-break: break-all;\n}\n\n/* Status badge styles moved to status-badge.css */\n\n/* Смена статуса жалобы: портал + оверлей + кастомный список (без нативного select) */\n.complaint-status-shell {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  pointer-events: none;\n}\n\n.complaint-status-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.38);\n  pointer-events: auto;\n  cursor: pointer;\n}\n\n[data-theme='dark'] .complaint-status-overlay {\n  background: rgba(0, 0, 0, 0.55);\n}\n\n.complaint-status-popup {\n  width: min(300px, calc(100vw - 32px));\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);\n  padding: 16px;\n  transform-origin: 50% 0;\n}\n\n.complaint-status-popup--portal {\n  position: fixed;\n  z-index: 1;\n  pointer-events: auto;\n}\n\n[data-theme='dark'] .complaint-status-popup {\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);\n}\n\n.complaint-status-popup__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.complaint-status-popup__close {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  line-height: 1;\n  color: var(--text-secondary);\n  padding: 4px 6px;\n  border-radius: 8px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.complaint-status-popup__close:hover {\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n}\n\n.complaint-status-popup__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* Кастомное поле статуса внутри попапа */\n.complaint-status-field {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.complaint-status-field__trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 10px 10px 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.complaint-status-field__trigger:hover:not(:disabled) {\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.2);\n}\n\n.complaint-status-field__trigger:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.complaint-status-field__label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.complaint-status-field__chevron {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  margin-right: 2px;\n  border-radius: 8px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  transition: transform 0.2s ease, border-color 0.15s ease;\n}\n\n.complaint-status-field__chevron--open {\n  transform: rotate(180deg);\n}\n\n.complaint-status-field__menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 6px);\n  z-index: 2;\n  padding: 6px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n[data-theme='dark'] .complaint-status-field__menu {\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);\n}\n\n.complaint-status-field__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.12s ease;\n}\n\n.complaint-status-field__option:hover {\n  background: var(--nav-hover-bg);\n}\n\n.complaint-status-field__option--active {\n  background: rgba(59, 130, 246, 0.08);\n  color: var(--accent-primary);\n}\n\n.complaint-status-field__check {\n  flex-shrink: 0;\n  opacity: 0.85;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: var(--bg-secondary);\n  padding: 2rem;\n  border-radius: 20px;\n  width: 92%;\n  max-width: 480px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--border-color);\n}\n\n.modal-content h3 {\n  margin: 0 0 1.5rem;\n  color: var(--text-primary);\n  font-size: 1.25rem;\n  font-weight: 700;\n  text-align: center;\n}\n\n.status-options {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.status-option {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  cursor: pointer;\n  padding: 1rem;\n  border-radius: 12px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid var(--border-color);\n  background: var(--bg-primary);\n}\n\n.status-option:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n  transform: translateX(4px);\n}\n\n.status-option input[type=\"radio\"] {\n  margin: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  accent-color: var(--accent-primary);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n.cancel-button,\n.confirm-button {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.9375rem;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.cancel-button {\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n}\n\n.cancel-button:hover { \n  background: var(--nav-hover-bg); \n  color: var(--text-primary);\n}\n\n.confirm-button {\n  background: var(--accent-primary);\n  color: #fff;\n  border: none;\n  box-shadow: var(--shadow-sm);\n}\n\n.confirm-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n  background: var(--accent-hover);\n}\n\n.confirm-button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* Loading and Error States */\n\n.error-message {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  padding: 1.5rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  font-weight: 600;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: var(--text-secondary);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.empty-state-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent-primary);\n  opacity: 0.8;\n}\n\n.empty-state-text {\n  font-size: 1.125rem;\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n/* Clickable UUID */\n.clickable-uuid {\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 8px;\n  padding: 0.5rem;\n  margin: -0.5rem;\n  border: 1px solid transparent;\n}\n\n.clickable-uuid:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n  transform: translateY(-1px);\n}\n\n.click-hint {\n  display: block;\n  font-size: 0.8125rem;\n  color: var(--accent-primary);\n  margin-top: 0.25rem;\n  opacity: 0;\n  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-weight: 600;\n}\n\n.clickable-uuid:hover .click-hint { opacity: 1; }\n.clickable-uuid:hover .uuid {\n  background: var(--bg-primary);\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.link-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 8px 16px;\n  border-radius: 999px;\n  border: 1px solid var(--accent-primary);\n  background: rgba(139, 92, 246, 0.1);\n  color: var(--accent-primary);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.link-chip:hover {\n  background: var(--accent-primary);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Responsive Design */\n@media (max-width: 900px) {\n  .complaint-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 768px) {\n  .complaint-details-container {\n    padding: 1rem;\n    margin-top: 52px;\n  }\n\n  .complaint-title {\n    font-size: 1.65rem;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-content {\n    width: 96%;\n    padding: 1.4rem;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 640px) {\n  .complaint-details-container {\n    padding: 0.75rem;\n  }\n\n  .metadata-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Focus states for accessibility */\n.back-button:focus,\n.status-update-button:focus,\n.cancel-button:focus,\n.confirm-button:focus,\n.status-option:focus-within {\n  outline: 2px solid #6366f1;\n  outline-offset: 2px;\n}\n\n/* Review/Comment Card Styles */\n.review-card {\n  grid-column: 1 / -1;\n}\n\n.review-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.review-comment-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.review-comment-section label {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  letter-spacing: 0.05em;\n  display: block;\n}\n\n.review-comment-text {\n  background: var(--bg-primary);\n  padding: 1.5rem;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  line-height: 1.6;\n  white-space: pre-wrap;\n  font-size: 1rem;\n  color: var(--text-primary);\n  min-height: 80px;\n}\n\n.review-comment-date {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n  padding-left: 0.25rem;\n}\n\n.review-navigation-buttons {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.review-navigation-buttons .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-decoration: none;\n  font-family: inherit;\n}\n\n.review-navigation-buttons .btn-primary {\n  background: var(--accent-primary);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.review-navigation-buttons .btn-primary:hover {\n  transform: translateY(-1px);\n  background: var(--accent-hover);\n  box-shadow: var(--shadow-md);\n}\n\n.review-navigation-buttons .btn-secondary {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n}\n\n.review-navigation-buttons .btn-secondary:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n}\n\n.review-placeholder {\n  padding: 2rem;\n  text-align: center;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n.retry-button {\n  margin-top: 1rem;\n  padding: 10px 20px;\n  background: var(--accent-primary);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.9375rem;\n  box-shadow: var(--shadow-sm);\n}\n\n.retry-button:hover {\n  transform: translateY(-1px);\n  background: var(--accent-hover);\n  box-shadow: var(--shadow-md);\n}\n\n/* Print Styles */\n@media print {\n  .complaint-details-container {\n    background: white;\n    margin-top: 0;\n    padding: 1rem;\n  }\n\n  .complaint-header .status-update-button,\n  .modal-overlay {\n    display: none;\n  }\n\n  .info-card {\n    box-shadow: none;\n    border: 1px solid #e5e7eb;\n  }\n}\n/* Тёмная тема (DEV): контейнер деталей жалобы был белым */\n:root[data-theme='dark'] .complaint-details-container {\n  background: var(--bg-card);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
